import { Skeleton, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Header from '/@/components/bayer/header';
import PageContainer from '/@/components/bayer/page-container';
import Tabs from '/@/components/bayer/tabs';
import { useOwnUserNode, useUserNodes } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { MuiSelect } from '/@/mui/select';
import { getUser } from '/@/store/session/selectors';
import UserUIAlertAndModal from '../../rv/components/onboarding-modal-and-alert/user-ui-alert-and-modal';
import RecommendationsSection from '../components/home-recommendations-section';
import ResumeSection from '../components/home-resume-section';

const SquadHome = () => {
    const userNodeQuery = useOwnUserNode();
    const userNodeId = userNodeQuery.data?.id;
    const user = useSelector(getUser);
    const [selectedSquadNodeId, setSelectedSquadNodeId] = useState<number | undefined>(undefined);
    const userNodesQuery = useUserNodes({
        page_size: 10000,
        page: 1,
        node: userNodeId,
        type: 'squad',
        excludeTargetNode: true,
    });
    const squadsUserNodes = userNodesQuery.data?.results || [];

    useEffect(() => {
        if (!selectedSquadNodeId) {
            setSelectedSquadNodeId(squadsUserNodes[0]?.id);
        }
    }, [selectedSquadNodeId, squadsUserNodes]);

    const [yearFilter, setYearFilter] = useState<number>(new Date().getFullYear());

    return (
        <PageContainer
            boxProps={{ sx: { background: '#F5F5F5' } }}
            containerProps={{ sx: { py: 4 } }}
            header={
                <Header
                    title={
                        <>
                            {_('Hola, ')}
                            <span className='mp-mask'>{user?.first_name || ''}</span>
                        </>
                    }
                    subtitle={_('Accedé a una vista integrada del Squad.')}
                />
            }
        >
            <Stack className='mp-mask' spacing={4} sx={{ pt: 4 }}>
                <Stack my={3}>
                    <UserUIAlertAndModal />
                </Stack>
                <Stack spacing={3}>
                    <Stack
                        direction='row'
                        alignItems='center'
                        justifyContent='space-between'
                        flexWrap='wrap'
                        useFlexGap
                        spacing={2}
                    >
                        <Stack
                            width='40%'
                            minWidth='fit-content'
                            sx={{
                                background: 'white',
                            }}
                        >
                            {userNodesQuery.isValidating ? (
                                <Skeleton variant='rectangular' height={40} width={400} />
                            ) : (
                                <Tabs
                                    options={squadsUserNodes.map((squad) => ({
                                        label: squad.name,
                                        value: squad.id.toString(),
                                    }))}
                                    value={selectedSquadNodeId?.toString() ?? undefined}
                                    setValue={(value: string) => setSelectedSquadNodeId(Number(value))}
                                />
                            )}
                        </Stack>
                        <MuiSelect
                            key='campaign-selector'
                            value={yearFilter}
                            onChange={(e) => setYearFilter(Number(e.target.value))}
                            type='number'
                            inputLabel={_('Campaña')}
                            options={Array.from({ length: 5 }, (_, index) => ({
                                label:
                                    (new Date().getFullYear() - index).toString() +
                                    ' / ' +
                                    (new Date().getFullYear() - index + 1),
                                value: (new Date().getFullYear() - index).toString(),
                            }))}
                            sx={{
                                minWidth: 'fit-content',
                                width: {
                                    md: 200,
                                },
                                background: 'white',
                            }}
                        />
                    </Stack>

                    <ResumeSection userNodeId={selectedSquadNodeId} year={yearFilter} />
                </Stack>
                <RecommendationsSection userNodeId={selectedSquadNodeId} year={yearFilter} />
            </Stack>
        </PageContainer>
    );
};

export default SquadHome;
